const TeamIntro = ({ language = "EN" }) => {

  const lang = language === "CN" ? "zh" : "en";

  const text = {
    en: {
      title1: "The",
      title2: "people",
      title3: "behind your journey.",
      p1:
        "At JT Group, our greatest asset is our people. We are a team of dedicated financial advisors, mentors, and leaders who share one common purpose: to serve our clients with excellence, honesty, and heart.",
      p2:
        "Every member of our team brings a unique background, perspective, and set of strengths — united by our shared values and our commitment to walking alongside every client on their financial journey.",
    },

    zh: {
      title1: "",
      title2: "团队",
      title3: "成就您的未来",
      p1:
        "在 JT Group，我们最大的资产是我们的团队。我们由专业顾问、导师与领导者组成，始终以卓越、诚信与责任服务客户。",
      p2:
        "团队中的每一位成员都拥有独特的背景与经验，我们以共同的价值观为基础，陪伴每位客户走过他们的财富旅程。",
    },
  };

  return (
    <section className="py-10 bg-white">
      <div className="max-w-6xl mx-auto px-6 text-center">

        <h2 className="text-[34px] font-medium text-[#154059] leading-snug">
          {text[lang].title1}{" "}
          <span className="text-[#C69C6D]">
            {text[lang].title2}
          </span>{" "}
          {text[lang].title3}
        </h2>

        <p className="text-gray-600 mt-5 leading-relaxed text-[15px] max-w-3xl mx-auto">
          {text[lang].p1}
        </p>

        <p className="text-gray-600 mt-4 leading-relaxed text-[15px] max-w-3xl mx-auto">
          {text[lang].p2}
        </p>

      </div>
    </section>
  );
};

export default TeamIntro;